// Chantier : Boilerplate lot 4 (PLAN/audits/audit-boilerplate/BACKLOG.md)
// Regle metier : -
// Decision : -
// Labels/styles du module demandes, extraits de lib/labels.ts
// (decontamination du socle, Axe 1).

// --- Demande labels (module 08, V13 V1 degraissee) ---

import type { StatutDemande, CategorieDemande, ObjetType } from '@/schemas/demande';

export const STATUT_DEMANDE_LABELS: Record<StatutDemande, string> = {
  a_traiter: 'En attente de traitement',
  en_cours: 'En cours de traitement',
  traite: 'Traité',
  annule_par_client: 'Annulée',
};

export const STATUT_DEMANDE_STYLE: Record<StatutDemande, { badge: string; border: string; dot: string }> = {
  a_traiter:         { badge: 'bg-orange-500 text-white', border: 'border-l-orange-500', dot: 'bg-orange-500' },
  en_cours:          { badge: 'bg-blue-500 text-white',   border: 'border-l-blue-500',   dot: 'bg-blue-500'   },
  traite:            { badge: 'bg-green-600 text-white',  border: 'border-l-green-600',  dot: 'bg-green-600'  },
  annule_par_client: { badge: 'bg-gray-400 text-white',   border: 'border-l-gray-400',   dot: 'bg-gray-400'   },
};

export const CATEGORIE_DEMANDE_LABELS: Record<CategorieDemande, string> = {
  information: 'Information',
  modification: 'Modification',
  annulation: 'Annulation',
  reclamation: 'Réclamation',
};

export const OBJET_TYPE_DEMANDE_LABELS: Record<ObjetType, string> = {
  chantier: 'Chantier',
  transport: 'Transport',
  cap: 'Déchet',
  bordereau: 'BSD',
  facture: 'Facture',
};
